/**
 *  @description :: Contact Us (WhatsApp) page within back admin panel
 *  @author :: Wong Shao Le
 */
'use client'
import React, { useState, useEffect, useRef } from "react";
import {Text, Group, Button, TextInput, Card, Stack } from "@mantine/core";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import { useForm } from '@mantine/form';
import { RowDataContact } from "./types";
import classes from "../ContactPage/Contact.module.css";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";

export function Contact() {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);

  const updateContact = async (data: RowDataContact) => {
      try {
          setIsLoading(true);
          const response = await axiosPrivate.post("/api/admin/contactwhatsapp/edit", data);
          showSuccessAlert("Contact Successfully Updated");
          console.log("[INFO] Contact for WhatsApp saved to database:", response.data);

      } catch (error: any) {
          showErrorAlert("Something Went Wrong");
          console.error(error);

      } finally {
          setIsLoading(false);
      }
  };
  
  const fetchContact = async () => {
      try {
        setIsLoading(true);
        const response = await axiosPrivate.get("/api/contactwhatsapp/get"); 
        const latestDetails = response.data.result;

        if (latestDetails) {
          form.setValues({
            phone_number: latestDetails.phone_number || "",
            message: latestDetails.message || "",
          });
        }
      } catch (err) {
        console.error("Failed to fetch contact [ERROR]:", err);
      } finally {
        setIsLoading(false);
      }
    };

  /* Validate form input */
  const form = useForm({
      initialValues: {
          phone_number: "",
          message: "",
      },
      validate: {
          phone_number: (value) => (value.trim().length < 1 
                        ? 'Please fill in the empty field' 
                        : value.trim().length < 9 
                          ? 'Invalid Phone Number' 
                          : !/^\d*$/.test(value.trim()) 
                            ? 'Invalid Phone Number' 
                            : null),
          message: (value) => null,
      },
  });

  useEffect(() => {
    fetchContact();
  }, []);

  return (
    <div className={classes.contactPageContainer}>
      <Header title="Contact Us (WhatsApp)" />
      <Card shadow="sm" radius="md">
        <Stack>
          <Text size="sm" c="dimmed">
            Configure your WhatsApp contact number and default message.
          </Text>

          <form onSubmit={form.onSubmit((values) => {updateContact(values)})}>

            <TextInput className={classes.Text}
              {...form.getInputProps('phone_number')}
              label="Phone Number"
              placeholder="123456789"
              leftSection={<Text fz="sm" c="black" style={{lineHeight:1}}>+60</Text>}
              maxLength={15}
              required
            />

            <TextInput className={classes.Text}
              {...form.getInputProps('message')}
              label="Prefilled Message"
              placeholder="Hi, I'd like to ask about..."
              maxLength={255}
              my="sm" 
            />

            <div style={{
              width: '50%',
              display: 'flex',
              gap: '10px',
            }}>
            <Button onClick={() => fetchContact()} className={classes.buttonReset} loading={isLoading}>
              Reset
            </Button>
            <Button type="submit" className={classes.buttonSaveChanges} loading={isLoading}>
              Save Changes
            </Button>
            </div>
          </form>
        </Stack>
      </Card>
    </div>
  );
}

export default Contact;
